import { gql, useQuery } from '@apollo/client';

const GET_PAPER = gql`
  query getPapers {
    getPapers {
      examType
      semester
    }
  }
`;

export const useExamsTypeAndSem = (): { examType: string; semester: string } | null => {
  const { data } = useQuery(GET_PAPER);

  if (data?.getPapers) {
    return {
      examType: data?.getPapers[0]?.examType,
      semester: data?.getPapers[0]?.semester === 1 ? 'one' : 'two',
    };
  }
  return null;
};
